<admin-header [primaryButtons]="headerPrimaryButtons" [tertiaryButtons]="headerTertiaryButtons" [title]="title" (eventFired)="headerButtonClick($event)"></admin-header>
<div class="form-container">
	<dx-form class="m-3" [(formData)]="item" [showColonAfterLabel]="true" labelLocation="top" [readOnly]="readOnly">
		<dxi-item itemType="tabbed" [tabPanelOptions]="{hoverStateEnabled:false}">
			<dxo-tab-panel-options [deferRendering]="false"></dxo-tab-panel-options>
			<dxi-tab title="Details">
				<dxi-item dataField="grid"></dxi-item>
			</dxi-tab>
			<dxi-tab title="Allowed Groups">
				<dx-data-grid #groupsGridContainer class="data-grid" [dataSource]="selectedGroups" [remoteOperations]="false" [allowColumnReordering]="false" [rowAlternationEnabled]="true" [showBorders]="true" height="200px">
					<dxo-paging [pageSize]="100"></dxo-paging>
					<dxo-pager [visible]="false" [showPageSizeSelector]="false" [allowedPageSizes]="[10, 25, 50, 100]"></dxo-pager>
					<dxo-search-panel [visible]="false" [highlightCaseSensitive]="true"></dxo-search-panel>
					<dxo-group-panel [visible]="false"></dxo-group-panel>
					<dxo-grouping [autoExpandAll]="false"></dxo-grouping>
					<dxo-export [enabled]="false"></dxo-export>
					<dxo-editing mode="popup" [allowAdding]="!readOnly" [allowDeleting]="!readOnly" [allowUpdating]="!readOnly" [confirmDelete]="true" [useIcons]="true" newRowPosition="last" [changes]="changes" [(editRowKey)]="editRowKey">
					<dxo-popup title="Allowed Group" [showTitle]="true" [width]="'75%'" [height]="'auto'"></dxo-popup>
						<dxo-form [colCount]="1">
							<dxi-item><p>Selected Groups can export the named Grid. Note that Super Admins and Executives can always do this; there is no need to include them below.</p></dxi-item>
							<dxi-item dataField="groupId" editorType="dxSelectBox" [editorOptions]="{ items: groups, searchEnabled: true, displayExpr:'name', valueExpr:'id'}" [label]="{ text: 'Group' }"></dxi-item>	
						</dxo-form>
					</dxo-editing>
					<dxo-toolbar>
						<dxi-item name="addRowButton" showText="always"></dxi-item>
					</dxo-toolbar>
					<dxi-column dataField="groupId" dataType="number" alignment="left" caption="Group">
						<dxo-lookup [dataSource]="groups" displayExpr="name" valueExpr="id"></dxo-lookup>
						<dxi-validation-rule type="required"></dxi-validation-rule>
					</dxi-column>
					<dxi-column type="buttons">
						<dxi-button name="edit"></dxi-button>
						<dxi-button name="delete"></dxi-button>
					</dxi-column>
				</dx-data-grid>
			</dxi-tab>
		</dxi-item>
	</dx-form>
</div>